import sendSegmentEvent from '@client/utils/segmentHelper'
import { getCookie } from '@client/services/cookies'
import { string, shape, oneOfType, number } from 'prop-types'

const sendFunnelSubmitEvent = (
  country,
  commonValues,
  utmQueryParams,
  filledCountry
) => {
  const hubspotutk = getCookie('hubspotutk')

  sendSegmentEvent('on_funnel_submitted', {
    leadsource: 'Inbound',
    page_name: `/digital/${country}/simulate/company-info`,
    page_source: `/digital/${country}/simulate/company-info`,
    ...commonValues,
    ...utmQueryParams,
    country: filledCountry,
    hubspotutk,
  })
}

export default sendFunnelSubmitEvent

sendFunnelSubmitEvent.propTypes = {
  country: string.isRequired,
  commonValues: shape({
    'first-name': string.isRequired,
    'last-name': string.isRequired,
    'work-email': string.isRequired,
    'employees-number': oneOfType([string, number]).isRequired,
  }),
  utmQueryParams: shape({}),
  filledCountry: string.isRequired,
}
